import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7087/Support";
	}
	getAgentIntegrationStatus(e, t, r) {
		let i = this.baseUrl + "/GetAgentIntegrationStatus";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		i += "agentId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetAgentIntegrationStatus(e)));
	}
	processGetAgentIntegrationStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? N("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailure(e, t) {
		let r = this.baseUrl + "/GetAutomationFailure";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'reference' must be defined and cannot be null.");
		r += "reference=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAutomationFailure(e)));
	}
	processGetAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailureMetrics(e, t) {
		let r = this.baseUrl + "/GetAutomationFailureMetrics";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		e !== void 0 && (r += "campaignId=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAutomationFailureMetrics(e)));
	}
	processGetAutomationFailureMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutomationFailures(e, t, r, i, a, o, s, c, l, u, d) {
		let p = this.baseUrl + "/GetAutomationFailures";
		if (p += "?", e === null) throw new globalThis.Error("The parameter 'search' cannot be null.");
		if (e !== void 0 && (p += "search=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'area' cannot be null.");
		if (t !== void 0 && (p += "area=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'reason' cannot be null.");
		if (r !== void 0 && (p += "reason=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (i !== void 0 && (p += "agencyId=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		if (a !== void 0 && (p += "campaignId=" + encodeURIComponent(f(a)) + "&"), o === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (o !== void 0 && (p += "status=" + encodeURIComponent(f(o)) + "&"), s === null) throw new globalThis.Error("The parameter 'occurredFromUtc' cannot be null.");
		if (s !== void 0 && (p += "occurredFromUtc=" + encodeURIComponent(f(s)) + "&"), c === null) throw new globalThis.Error("The parameter 'occurredToUtc' cannot be null.");
		if (c !== void 0 && (p += "occurredToUtc=" + encodeURIComponent(f(c)) + "&"), l === null) throw new globalThis.Error("The parameter 'continuationToken' cannot be null.");
		if (l !== void 0 && (p += "continuationToken=" + encodeURIComponent(f(l)) + "&"), u === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
		u !== void 0 && (p += "pageSize=" + encodeURIComponent(f(u)) + "&"), p = p.replace(/[?&]$/, "");
		let m = {
			method: "GET",
			url: p,
			headers: { Accept: "application/json" },
			signal: d
		};
		return this.transformOptions(m).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(p, e, (e) => this.processGetAutomationFailures(e)));
	}
	processGetAutomationFailures(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCommonInformationForMessage(e, t, r, i, a) {
		let o = this.baseUrl + "/GetCommonInformationForMessage";
		if (o += "?", e === null) throw new globalThis.Error("The parameter 'agentId' cannot be null.");
		if (e !== void 0 && (o += "agentId=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (t !== void 0 && (o += "agencyId=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		if (r !== void 0 && (o += "campaignId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
		i !== void 0 && (o += "userId=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processGetCommonInformationForMessage(e)));
	}
	processGetCommonInformationForMessage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLeaderboardVisibilityDetails(e, t) {
		let r = this.baseUrl + "/GetLeaderboardVisibilityDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLeaderboardVisibilityDetails(e)));
	}
	processGetLeaderboardVisibilityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLogsForServiceAtPeriod(e, t, r) {
		let i = this.baseUrl + "/GetLogsForServiceAtPeriod";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (i += "agxService=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'timeToSearchNear' must be defined and cannot be null.");
		i += "timeToSearchNear=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetLogsForServiceAtPeriod(e)));
	}
	processGetLogsForServiceAtPeriod(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getManualDocuSignUpdateCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetManualDocuSignUpdateCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetManualDocuSignUpdateCampaignDetails(e)));
	}
	processGetManualDocuSignUpdateCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getMigrations(e) {
		let t = this.baseUrl + "/GetMigrations", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMigrations(e)));
	}
	processGetMigrations(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPoisonQueueMessages(e, t, r) {
		let i = this.baseUrl + "/GetPoisonQueueMessages";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (i += "agxService=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'queueName' must be defined and cannot be null.");
		i += "queueName=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPoisonQueueMessages(e)));
	}
	processGetPoisonQueueMessages(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPoisonQueues(e) {
		let t = this.baseUrl + "/GetPoisonQueues", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetPoisonQueues(e)));
	}
	processGetPoisonQueues(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getSoftDeletedAgentsForAgency(e, t) {
		let r = this.baseUrl + "/GetSoftDeletedAgentsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetSoftDeletedAgentsForAgency(e)));
	}
	processGetSoftDeletedAgentsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUpdateCampaignStatusDetails(e, t) {
		let r = this.baseUrl + "/GetUpdateCampaignStatusDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUpdateCampaignStatusDetails(e)));
	}
	processGetUpdateCampaignStatusDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUpdateLegalNameCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetUpdateLegalNameCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUpdateLegalNameCampaignDetails(e)));
	}
	processGetUpdateLegalNameCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	reopenAutomationFailure(e, t) {
		let r = this.baseUrl + "/ReopenAutomationFailure", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processReopenAutomationFailure(e)));
	}
	processReopenAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	replayQueueMessage(e, t) {
		let r = this.baseUrl + "/ReplayQueueMessage", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processReplayQueueMessage(e)));
	}
	processReplayQueueMessage(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	resetAgentIntegration(e, t, r, i) {
		let a = this.baseUrl + "/ResetAgentIntegration";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (a += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		if (a += "agentId=" + encodeURIComponent(f(t)) + "&", r == null) throw new globalThis.Error("The parameter 'provider' must be defined and cannot be null.");
		a += "provider=" + encodeURIComponent(f(r)) + "&", a = a.replace(/[?&]$/, "");
		let o = {
			method: "POST",
			url: a,
			headers: {},
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processResetAgentIntegration(e)));
	}
	processResetAgentIntegration(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 ? N("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	resolveAutomationFailure(e, t) {
		let r = this.baseUrl + "/ResolveAutomationFailure", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processResolveAutomationFailure(e)));
	}
	processResolveAutomationFailure(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	restoreSoftDeletedAgent(e, t) {
		let r = this.baseUrl + "/RestoreSoftDeletedAgent", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRestoreSoftDeletedAgent(e)));
	}
	processRestoreSoftDeletedAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	setLeaderboardVisibility(e, t) {
		let r = this.baseUrl + "/SetLeaderboardVisibility", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetLeaderboardVisibility(e)));
	}
	processSetLeaderboardVisibility(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	startMigrationRun(e, t) {
		let r = this.baseUrl + "/StartMigrationRun", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStartMigrationRun(e)));
	}
	processStartMigrationRun(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCampaignStatus(e, t) {
		let r = this.baseUrl + "/UpdateCampaignStatus", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateCampaignStatus(e)));
	}
	processUpdateCampaignStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateContractStatus(e, t) {
		let r = this.baseUrl + "/UpdateContractStatus", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateContractStatus(e)));
	}
	processUpdateContractStatus(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateVendorLegalName(e, t) {
		let r = this.baseUrl + "/UpdateVendorLegalName", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateVendorLegalName(e)));
	}
	processUpdateVendorLegalName(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? N("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : N("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.Pdf = "Pdf", e.Rex = "Rex", e.RpData = "RpData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Identifier = "Identifier", e.Number = "Number", e.Boolean = "Boolean", e.Enum = "Enum", e.Date = "Date", e.Time = "Time", e.Instant = "Instant", e.LocalDateTime = "LocalDateTime", e.OffsetDateTime = "OffsetDateTime", e.Duration = "Duration", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.ManuallyActioned = "ManuallyActioned", e.Ignored = "Ignored", e.FalseAlarm = "FalseAlarm", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Email = "Email", e.Crm = "Crm", e.Tasks = "Tasks", e.Documents = "Documents", e.DocuSign = "DocuSign", e.CampaignFlow = "CampaignFlow", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e.Marketing = "Marketing", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.InvalidData = "InvalidData", e.ProviderUnavailable = "ProviderUnavailable", e.PermissionDenied = "PermissionDenied", e.RecordNotFound = "RecordNotFound", e.TimedOut = "TimedOut", e.Unexpected = "Unexpected", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Unresolved = "Unresolved", e.Resolved = "Resolved", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Agent = "Agent", e.Staff = "Staff", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Team = "Team", e.Agent = "Agent", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Verbose = "Verbose", e.Information = "Information", e.Warning = "Warning", e.Error = "Error", e.Critical = "Critical", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.AutoResponded = "AutoResponded", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.NotRun = "NotRun", e.InProgress = "InProgress", e.Successful = "Successful", e.Failed = "Failed", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.RpData = "RpData", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.PDF = "PDF", e.Rex = "Rex", e.RPData = "RPData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ManuallyActioned = "ManuallyActioned", e.Ignored = "Ignored", e.FalseAlarm = "FalseAlarm", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Agency = "Agency", e.Team = "Team", e.Agent = "Agent", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e.ProposalDraft = "ProposalDraft", e;
}({}), M = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isSupportApiException = !0;
	static isSupportApiException(e) {
		return e.isSupportApiException === !0;
	}
};
function N(e, t, n, r, i) {
	throw i ?? new M(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var P = "support";
function F(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var I = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), F(r);
}, L = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[P] || `${e}/${P}`;
}, R = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = L(i), u = c, d = I(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = I(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, z = a({}), B = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = R(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(z.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, V = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(z), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAgentIntegrationStatus",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getAgentIntegrationStatus(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, H = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAgentIntegrationStatus",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, U = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getAutomationFailure", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getAutomationFailure(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, W = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAutomationFailure", e] });
	}, e[0] = t, e[1] = n), n;
}, G = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getAutomationFailureMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getAutomationFailureMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, K = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAutomationFailureMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, q = (e, t, n, i, a, s, c, l, d, f, p) => {
	let m = r(31), h = p === void 0 || p, g = o(z), _;
	m[0] !== i || m[1] !== t || m[2] !== a || m[3] !== d || m[4] !== c || m[5] !== l || m[6] !== f || m[7] !== n || m[8] !== e || m[9] !== s ? (_ = [
		"getAutomationFailures",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d,
		f
	], m[0] = i, m[1] = t, m[2] = a, m[3] = d, m[4] = c, m[5] = l, m[6] = f, m[7] = n, m[8] = e, m[9] = s, m[10] = _) : _ = m[10];
	let v = _, y;
	m[11] !== i || m[12] !== g || m[13] !== t || m[14] !== a || m[15] !== d || m[16] !== c || m[17] !== l || m[18] !== f || m[19] !== n || m[20] !== e || m[21] !== s ? (y = (r) => {
		let { signal: o } = r;
		return g.getAutomationFailures(e, t, n, i, a, s, c, l, d, f, o);
	}, m[11] = i, m[12] = g, m[13] = t, m[14] = a, m[15] = d, m[16] = c, m[17] = l, m[18] = f, m[19] = n, m[20] = e, m[21] = s, m[22] = y) : y = m[22];
	let b = h && !!g, x;
	m[23] !== v || m[24] !== y || m[25] !== b ? (x = {
		queryKey: v,
		queryFn: y,
		enabled: b
	}, m[23] = v, m[24] = y, m[25] = b, m[26] = x) : x = m[26];
	let { data: S, isPending: C, isError: w } = u(x), T;
	return m[27] !== S || m[28] !== w || m[29] !== C ? (T = {
		data: S,
		isPending: C,
		isError: w
	}, m[27] = S, m[28] = w, m[29] = C, m[30] = T) : T = m[30], T;
}, J = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l, u) => {
		await t.invalidateQueries({ queryKey: [
			"getAutomationFailures",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l,
			u
		] });
	}, e[0] = t, e[1] = n), n;
}, Y = (e, t, n, i, a) => {
	let s = r(19), c = a === void 0 || a, l = o(z), d;
	s[0] !== t || s[1] !== e || s[2] !== n || s[3] !== i ? (d = [
		"getCommonInformationForMessage",
		e,
		t,
		n,
		i
	], s[0] = t, s[1] = e, s[2] = n, s[3] = i, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== t || s[6] !== e || s[7] !== l || s[8] !== n || s[9] !== i ? (p = (r) => {
		let { signal: a } = r;
		return l.getCommonInformationForMessage(e, t, n, i, a);
	}, s[5] = t, s[6] = e, s[7] = l, s[8] = n, s[9] = i, s[10] = p) : p = s[10];
	let m = c && !!l, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v } = u(h), y;
	return s[15] !== g || s[16] !== v || s[17] !== _ ? (y = {
		data: g,
		isPending: _,
		isError: v
	}, s[15] = g, s[16] = v, s[17] = _, s[18] = y) : y = s[18], y;
}, X = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i) => {
		await t.invalidateQueries({ queryKey: [
			"getCommonInformationForMessage",
			e,
			n,
			r,
			i
		] });
	}, e[0] = t, e[1] = n), n;
}, Z = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getLeaderboardVisibilityDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getLeaderboardVisibilityDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getLeaderboardVisibilityDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(z), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getLogsForServiceAtPeriod",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getLogsForServiceAtPeriod(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ne = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getLogsForServiceAtPeriod",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, re = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getManualDocuSignUpdateCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getManualDocuSignUpdateCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ie = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getManualDocuSignUpdateCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ae = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(z), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMigrations"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMigrations(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getMigrations"] });
	}, e[0] = t, e[1] = n), n;
}, se = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(z), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPoisonQueueMessages",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPoisonQueueMessages(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPoisonQueueMessages",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, le = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(z), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getPoisonQueues"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getPoisonQueues(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getPoisonQueues"] });
	}, e[0] = t, e[1] = n), n;
}, de = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getSoftDeletedAgentsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getSoftDeletedAgentsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getSoftDeletedAgentsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateCampaignStatusDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateCampaignStatusDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateCampaignStatusDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, he = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(z), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateLegalNameCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateLegalNameCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateLegalNameCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.reopenAutomationFailure(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		reopenAutomationFailure: u,
		reopenAutomationFailurePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ve = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.replayQueueMessage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		replayQueueMessage: u,
		replayQueueMessagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, agentId: n, provider: r } = e;
		return a.resetAgentIntegration(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		resetAgentIntegration: u,
		resetAgentIntegrationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, be = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.resolveAutomationFailure(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		resolveAutomationFailure: u,
		resolveAutomationFailurePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $ = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.restoreSoftDeletedAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		restoreSoftDeletedAgent: u,
		restoreSoftDeletedAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setLeaderboardVisibility(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setLeaderboardVisibility: u,
		setLeaderboardVisibilityPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Se = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.startMigrationRun(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		startMigrationRun: u,
		startMigrationRunPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ce = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateCampaignStatus(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateCampaignStatus: u,
		updateCampaignStatusPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, we = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateContractStatus(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateContractStatus: u,
		updateContractStatusPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Te = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(z), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateVendorLegalName(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateVendorLegalName: u,
		updateVendorLegalNamePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { m as AgxService, h as AutomationContextAttributeType, g as AutomationFailureResolutionType, _ as AutomationFailureResponseArea, v as AutomationFailureResponseReason, y as AutomationFailureResponseStatus, b as AutomationFailureResponseUserType, x as LeaderboardEntityVisibilitySummaryEntityType, S as LogEntrySeverityLevel, C as ManualDocuSignUpdateEnvelopeDetailsStatus, w as ManualDocuSignUpdateRecipientDetailsStatus, T as MigrationRunDetailsStatus, E as Provider, D as ReplayQueueMessageRequestService, O as ResolveAutomationFailureRequestResolution, k as SetLeaderboardVisibilityRequestEntityType, z as SupportApiContext, M as SupportApiException, B as SupportApiProvider, p as SupportClient, P as SupportRoute, A as UpdateCampaignStatusCampaignDetailsCurrentStage, j as UpdateCampaignStatusRequestStage, ee as UpdateCampaignStatusStageOptionStage, V as useGetAgentIntegrationStatus, U as useGetAutomationFailure, G as useGetAutomationFailureMetrics, q as useGetAutomationFailures, Y as useGetCommonInformationForMessage, Z as useGetLeaderboardVisibilityDetails, Q as useGetLogsForServiceAtPeriod, re as useGetManualDocuSignUpdateCampaignDetails, ae as useGetMigrations, se as useGetPoisonQueueMessages, le as useGetPoisonQueues, de as useGetSoftDeletedAgentsForAgency, pe as useGetUpdateCampaignStatusDetails, he as useGetUpdateLegalNameCampaignDetails, H as useInvalidateUseGetAgentIntegrationStatus, W as useInvalidateUseGetAutomationFailure, K as useInvalidateUseGetAutomationFailureMetrics, J as useInvalidateUseGetAutomationFailures, X as useInvalidateUseGetCommonInformationForMessage, te as useInvalidateUseGetLeaderboardVisibilityDetails, ne as useInvalidateUseGetLogsForServiceAtPeriod, ie as useInvalidateUseGetManualDocuSignUpdateCampaignDetails, oe as useInvalidateUseGetMigrations, ce as useInvalidateUseGetPoisonQueueMessages, ue as useInvalidateUseGetPoisonQueues, fe as useInvalidateUseGetSoftDeletedAgentsForAgency, me as useInvalidateUseGetUpdateCampaignStatusDetails, ge as useInvalidateUseGetUpdateLegalNameCampaignDetails, _e as useReopenAutomationFailure, ve as useReplayQueueMessage, ye as useResetAgentIntegration, be as useResolveAutomationFailure, $ as useRestoreSoftDeletedAgent, xe as useSetLeaderboardVisibility, Se as useStartMigrationRun, R as useSupportClientContext, Ce as useUpdateCampaignStatus, we as useUpdateContractStatus, Te as useUpdateVendorLegalName };
